import { connect } from 'react-redux'
import App from './components/App/App'

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ auth: state.auth }), mapDispatchToProps)(App)
